var map = {
	"./en/aiconsultant.json": 65,
	"./en/aisettings.json": 3773,
	"./en/cabinetpage.json": 1857,
	"./en/chats.json": 3581,
	"./en/generalInfo.json": 2954,
	"./en/knowledge_base.json": 3894,
	"./en/leads.json": 1537,
	"./en/sidebar.json": 2670,
	"./en/subscription.json": 355,
	"./pl/aiconsultant.json": 5420,
	"./pl/aisettings.json": 5932,
	"./pl/cabinetpage.json": 3282,
	"./pl/chats.json": 4970,
	"./pl/generalInfo.json": 2769,
	"./pl/knowledge_base.json": 6963,
	"./pl/leads.json": 858,
	"./pl/sidebar.json": 949,
	"./pl/subscription.json": 4398,
	"./ua/aiconsultant.json": 8610,
	"./ua/aisettings.json": 8854,
	"./ua/cabinetpage.json": 8560,
	"./ua/chats.json": 8752,
	"./ua/generalInfo.json": 5335,
	"./ua/knowledge_base.json": 1621,
	"./ua/leads.json": 2548,
	"./ua/sidebar.json": 1519,
	"./ua/subscription.json": 9556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4824;